<template>
    <div class="admin-vue-kit__panel admin-island-panel">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'AdminIslandPanel',
};
</script>
